import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import FinalidadeBaseApoioListActions from '../ducks/finalidade-base-apoio-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-finalidade-base-apoio`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(FinalidadeBaseApoioListActions.success(data, pagination));
  } catch (err) {
    yield put(
      FinalidadeBaseApoioListActions.failure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-finalidade-base-apoio?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(FinalidadeBaseApoioListActions.showSuccess(list));
  } catch (err) {
    yield put(
      FinalidadeBaseApoioListActions.showFailure(
        err.response.data.error.message,
      ),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
